import React, { useEffect } from 'react';
import LoadingSpinner from '../../../../atoms/loading-spinner';
import Explorer from '../../../../../data-containers/explorer';
import LocationDetails from '../../../../../data-containers/location-details';
import DynamicCell from '../../../../atoms/table/dynamic-cell';
import ErrorWithTooltip from '../../../../atoms/error-with-tooltip';
import HistoricalTotals from './historical-totals';

function GridOffsetContent(props) {
  // TODO put all of this functionality into a custom hook
  const { dateRange } = Explorer.useContainer();
  const { getDetail, fetchHistoricalForLocation, passiveFetchMetadata } = LocationDetails.useContainer();
  const { id } = props.rowData;
  const { historical, metadata } = getDetail(id) || {};
  const { [dateRange.id]: { data, loading, error }={} } = historical || {};

  useEffect(
    () => {
      if(id && !metadata){
        passiveFetchMetadata(id);
      }
    },
    [id]
  );

  useEffect(() => {
    if (id && dateRange?.id) {
      fetchHistoricalForLocation(id, { dateRange });
    }
  }, [id, dateRange.id]);

  if (loading) {
    return <LoadingSpinner className="inline" />;
  }
  if (error) {
    return <ErrorWithTooltip error={error} />;
  }
  if (metadata && !metadata.production) {
    return <div className="na">—</div>;
  }

  if (data) {
    return <HistoricalTotals historicalData={data} type="offset" omitDelta={true} historicalUnit="percent" inverted={true} />
  }
  return <div className="na">—</div>;
}

export default DynamicCell(GridOffsetContent);